import React from 'react';
import { motion } from 'framer-motion';
interface OrderBumpProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}
export function OrderBump({
  checked,
  onChange
}: OrderBumpProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="w-full max-w-xs mx-auto" data-id="element-94">
      <div className="rounded-xl border border-slate-400 bg-[#F9F9F9] p-4 shadow-sm aspect-square flex flex-col justify-between" data-id="element-95">
        {/* Header: Image + Title + Price */}
        <div className="flex items-start gap-3" data-id="element-96">
          <div className="flex-shrink-0 w-14 h-14 rounded-lg overflow-hidden bg-gray-200" data-id="element-97">
            <img src="https://cdn.magicpatterns.com/uploads/qyoN8PHt3HvP9gk6Zb92Y9/order_bump1.png" alt="21 Guiones Magnéticos" className="w-full h-full object-cover" data-id="element-98" />
          </div>
          <div className="flex-1 min-w-0" data-id="element-99">
            <h4 className="text-gray-900 font-extrabold text-xs leading-tight tracking-tight" data-id="element-100">
              21 GUIONES MAGNÉTICOS™
            </h4>
            <div className="flex items-center gap-1.5 mt-1" data-id="element-101">
              <span className="text-gray-400 line-through text-[10px]" data-id="element-102">
                $21.00
              </span>
              <span className="text-[#D4AF37] font-extrabold text-sm" data-id="element-103">
                $7.00
              </span>
            </div>
          </div>
        </div>

        {/* Persuasion text */}
        <p className="text-gray-600 text-[10px] leading-snug mt-3" data-id="element-104">
          ¿Te da miedo qué decir cuando alguien te pregunta de qué trata tu
          negocio? No dejes que el esfuerzo de atraer prospectos se pierda por
          no saber cerrar la conversación. Con este{' '}
          <strong className="text-gray-800" data-id="element-105">"Cargador de DMs"</strong> tendrás
          las palabras exactas para llevar a cualquier interesado de Instagram a
          una presentación por Zoom o WhatsApp sin parecer desesperado.
        </p>
        <p className="text-gray-500 text-[9px] italic mt-1.5" data-id="element-106">
          (Oferta única: Solo disponible en esta página. Ahorra un 67% del
          precio original)
        </p>

        {/* Checkbox action */}
        <div className="mt-3 pt-3 border-t border-gray-200" data-id="element-107">
          <label className="flex items-center gap-2 cursor-pointer group" onClick={e => {
          e.stopPropagation();
          onChange(!checked);
        }} data-id="element-108">
            <div className="flex-shrink-0" data-id="element-109">
              <motion.div animate={{
              boxShadow: checked ? '0 0 0 0 rgba(212,175,55,0)' : ['0 0 0 0 rgba(212,175,55,0.3)', '0 0 0 5px rgba(212,175,55,0)']
            }} transition={{
              duration: 1.4,
              repeat: checked ? 0 : Infinity,
              repeatType: 'loop'
            }} className="rounded" data-id="element-110">
                <div className={`w-5 h-5 rounded border-2 flex items-center justify-center transition-all ${checked ? 'bg-[#D4AF37] border-[#D4AF37]' : 'bg-white border-gray-400 group-hover:border-[#D4AF37]'}`} data-id="element-111">
                  {checked && <motion.svg initial={{
                  scale: 0
                }} animate={{
                  scale: 1
                }} className="w-3 h-3 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-112">
                      <polyline points="20 6 9 17 4 12" data-id="element-113" />
                    </motion.svg>}
                </div>
              </motion.div>
            </div>
            <span className="text-gray-900 font-bold text-[11px] leading-tight" data-id="element-114">
              ✅ ¡SÍ! AGREGAR POR SOLO $7.00
            </span>
          </label>
        </div>
      </div>
    </motion.div>;
}